import React from 'react';
import { Helmet } from 'react-helmet';
import checkmark from './images/checkmark.svg';
import { H2, H3, Link } from '@leafygreen-ui/typography';
import Layout from './Layout';
import { MultiFactorAuthContainer } from './styles/multiFactorPage';
import HeaderLogo from './HeaderLogo';
import Card from '@leafygreen-ui/card';
import { header } from './styles/form';

export function DeviceAuthSuccessPage() {
  return (
    <>
      <Helmet title="Activation" />
      <Layout contentPlacement="right">
        <MultiFactorAuthContainer>
          <HeaderLogo />
          <H2 css={header}> Activation</H2>
          <Card css={{ minHeight: 200, maxWidth: 500 }}>
            <div css={{ textAlign: 'center' }}>
              <img src={checkmark} alt="success checkmark" css={{ marginBottom: 20, marginTop: 10 }} />
              <H3>You&apos;re all set!</H3>
              <p css={{ fontSize: 15, fontWeight: 400 }}>Return to your CLI</p>
              <Link href="https://docs.mongodb.com/mongocli/stable/">MongoDB CLI docs</Link>
            </div>
          </Card>
        </MultiFactorAuthContainer>
      </Layout>
    </>
  );
}
